export const EMIT_MAP = {
  onError: "error",
  onWarning: "warning",
  onDataSynced: "dataSynced",
  onShowToolbar: "showToolbar",
  onReady: "ready",
  onTabGotoBoard: "tabGotoBoard",
  onTabSwitchFile: "tabSwitchFile",
  onScaleBoard: "scaleBoard",
  onCanUndoStatus: "canUndoStatus",
  onCanRedoStatus: "canRedoStatus",
  onRemoveElement: "removeElement",
};
